/**
 * Single source of truth for RARE GROUP public contact info.
 * Update HERE — these constants flow to every Contact/Support/Footer/CTA
 * across the whole site & PWA.
 */

// Voice call (call us / اتصل بنا) — answered by customer service.
export const CONTACT_PHONE_E164 = "+97440010300";
export const CONTACT_PHONE_DISPLAY = "+974 4001 0300";

// WhatsApp (24/7 chat) — official customer service number (Meta Business).
export const CONTACT_WHATSAPP_E164 = "+97430040348";
export const CONTACT_WHATSAPP_DISPLAY = "+974 3004 0348";
// wa.me requires digits only, no '+', no spaces.
export const CONTACT_WHATSAPP_URL = "https://wa.me/97430040348";

// E-mail — kept for completeness (used on InfoPage / footer).
export const CONTACT_EMAIL = "support@rgpro.info";

// Pre-filled WhatsApp message (link-encoded so it pops as the first line
// in the chat). Use:  `${CONTACT_WHATSAPP_URL}?text=${encodeURIComponent(msg)}`
export const WA_DEFAULT_MESSAGE_AR =
  "السلام عليكم 👋\nأود التواصل مع خدمة العملاء في RARE GROUP.";
export const WA_DEFAULT_MESSAGE_EN =
  "Hello 👋\nI'd like to contact RARE GROUP customer service.";

// Convenience helper used inside React components.
export function waLink(lang = "ar", extra = "") {
  const base = CONTACT_WHATSAPP_URL;
  const msg = (lang === "ar" ? WA_DEFAULT_MESSAGE_AR : WA_DEFAULT_MESSAGE_EN)
              + (extra ? `\n${extra}` : "");
  return `${base}?text=${encodeURIComponent(msg)}`;
}
